import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {

	init() {

		function ContactForm3ScrollMagic( container ) {

			var controller = new ScrollMagic.Controller();

			new ScrollMagic.Scene({triggerElement: container, triggerHook: 0.9 })
					// trigger animation by adding a css class
					.setClassToggle(container, "backToPosition")
					// .addIndicators({name: "- ContactForm3 "}) // add indicators (requires plugin)
					.addTo(controller)
					.offset(1);

		}


		function ContactFormLiveChatOpen( container ) {

			var button = container.querySelector('.box__liveChat');

			button.addEventListener('click', function(e) {

				e.preventDefault();

				if( typeof LC_API !== 'undefined' ) {

					LC_API.open_chat_window();

				} else {		

					window.open(
						button.getAttribute('href'),
						'_blank'
					);

				}

			});

		}


		var container = document.querySelectorAll('.contactForm3');

		if( container.length > 0 ) {
			
			container.forEach( function( box,index ) {

				ContactForm3ScrollMagic( box );
				ContactFormLiveChatOpen( box );

			});

		}

	},
	finalize() {

	}

}